import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import api from "../lib/api";
import { useAuth } from "../lib/auth";
import Logo from "../components/Logo";
import { GlassButton } from "../components/PrimaryButton";

// After Google sign-in, if user has no role we land here.
// They pick a role then we route them to the next step in the funnel.
const PickRole = () => {
  const { user, refresh } = useAuth();
  const nav = useNavigate();

  useEffect(() => {
    // Already has role? skip.
    if (user && user.role) {
      if (user.subscription_status !== "active") nav("/subscribe", { replace: true });
      else if (!user.onboarding_completed) nav("/onboarding", { replace: true });
      else nav("/dashboard", { replace: true });
    }
  }, [user, nav]);

  const choose = async (role) => {
    try {
      await api.post("/auth/set-role", { role });
      const u = await refresh();
      if (u?.subscription_status === "active") {
        if (!u.onboarding_completed) window.location.replace("/onboarding");
        else if (u.role === "client" && !u.linked_practitioner_id) window.location.replace("/link-practitioner");
        else window.location.replace("/dashboard");
      } else {
        window.location.replace("/subscribe");
      }
    } catch (e) {
      alert("Could not set role: " + (e?.response?.data?.detail || e.message));
    }
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center px-6 py-16 gap-12 well-page-enter">
      <Logo size="text-6xl" showTagline />
      <div className="text-center max-w-sm">
        <h2 className="text-xl font-semibold text-[#2A3B32]">Which best describes you?</h2>
        <p className="mt-2 text-sm text-[#4A5D52]">Pick your account type to continue.</p>
      </div>
      <div className="w-full max-w-sm flex flex-col gap-4">
        <GlassButton onClick={() => choose("therapist")} data-testid="pick-therapist">I&apos;m a Therapist</GlassButton>
        <GlassButton onClick={() => choose("coach")} data-testid="pick-coach">I&apos;m a Coach</GlassButton>
        <GlassButton onClick={() => choose("client")} data-testid="pick-client">I&apos;m a Client</GlassButton>
      </div>
    </div>
  );
};

export default PickRole;
